import { ProductUserViewEnum } from "@saleor/types/globalTypes";

import { ProductsUser } from "../customTypes/ProductsUser";
import {
  kamsProductUrl,
  KAMSProductUrlQueryParams,
  ProductListUrlQueryParams,
  productUrl,
  ProductUrlQueryParams
} from "../urls";

export default function getProductUpdateUrlByUserType(
  productUser: ProductsUser,
  productId: string,
  params:
    | ProductUrlQueryParams
    | KAMSProductUrlQueryParams
    | ProductListUrlQueryParams
): string {
  if (productUser.isKAMS && "viewAs" in params) {
    return kamsProductUrl(productId, {
      brand: params.brand,
      viewAs: params.viewAs as ProductUserViewEnum,
      ...(productUser.isStoreAdmin && {
        mallId: params.mallId,
        tenant: params.tenant
      })
    });
  }
  return productUrl(productId);
}
